export default __webpack_public_path__ + "static/background-3-09a45ea409e8630740b7136e888aff87.png";